import React, { useState } from 'react';
import axios from 'axios';
import '../styles/RSVP.css';
import headerImage from '../Images/rsvpheader1.png';

function Rsvp() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [searchResult, setSearchResult] = useState('');
  const [questionsVisible, setQuestionsVisible] = useState(false);
  const [groupMembers, setGroupMembers] = useState([]);
  const [attendance, setAttendance] = useState({});
  const [foodChoices, setFoodChoices] = useState({});
  const [restrictions, setRestrictions] = useState({});
  const [rsvpSubmitted, setRsvpSubmitted] = useState(false);
  const [plusOneAttendance, setPlusOneAttendance] = useState({});
  const [plusOneNames, setPlusOneNames] = useState({});
  const [plusOneFoodChoices, setPlusOneFoodChoices] = useState({});
  const [plusOneRestrictions, setPlusOneRestrictions] = useState({});
  const [rehearsalAttendance, setRehearsalAttendance] = useState({});
  const [rehearsalDinnerAttendance, setRehearsalDinnerAttendance] = useState({});
  const [plusOneRehearsal, setPlusOneRehearsal] = useState({});
  const [plusOneRehearsalDinner, setPlusOneRehearsalDinner] = useState({});

  

  // Search guest
  const handleFormSubmit = (e) => {
    e.preventDefault();

    const trimmedFirstName = firstName.trim();
    const trimmedLastName = lastName.trim();

    axios.get(`https://ww-backend-1-production.up.railway.app/search_guest?first_name=${trimmedFirstName}&last_name=${trimmedLastName}`)
      .then(response => {
        if (!response.data.found) {
          setSearchResult("Sorry, we couldn't find your invitation. Please check your name and try again or try another guest in your party.");
          return;
        }

        const guest = response.data;
        setSearchResult(`So glad you found us, ${guest.first_name} ${guest.last_name}`);

        if (guest.group_id) {
          axios.get(`https://ww-backend-1-production.up.railway.app/get_group_members?group_id=${guest.group_id}`)
            .then(groupRes => {
              const members = groupRes.data.members || [guest];
              initializeRSVPState(members);
            })
            .catch(() => {
              initializeRSVPState([guest]);
            });
        } else {
          initializeRSVPState([guest]);
        }
      })
      .catch(() => {
        setSearchResult("Sorry, we couldn't find your invitation. Please check your name and try again or someone in your party.");
      });
  };

  // Initialize RSVP state
  const initializeRSVPState = (members) => {
    const initAttendance = {};
    const initPlusOneAttendance = {};
    const initPlusOneNames = {};
    const initFoodChoices = {};
    const initRestrictions = {};
    const initPlusOneFoodChoices = {};
    const initPlusOneRestrictions = {};
    const initRehearsalAttendance = {};
    const initRehearsalDinnerAttendance = {};
    const initPlusOneRehearsal = {};
    const initPlusOneRehearsalDinner = {};

    members.forEach(member => {
      // Main guest
      initAttendance[member.id] = member.attendance_status === 1
        ? (member.attending ? 'Accept' : 'Decline')
        : '';
      initFoodChoices[member.id] = member.food_choice || '';
      initRestrictions[member.id] = member.food_restrictions || '';
      initRehearsalAttendance[member.id] = member.rehearsal_res ? (member.rehearsal_res ? 'Accept' : 'Decline') : '';
      initRehearsalDinnerAttendance[member.id] = member.rehearsal_dinner_res ? (member.rehearsal_dinner_res ? 'Accept' : 'Decline') : '';

      // Plus One
      if (member.plus_one_id) {
        initPlusOneAttendance[member.id] = member.plus_one?.attendance_status === 1
          ? (member.plus_one.attending ? 'Accept' : 'Decline')
          : '';
        initPlusOneNames[member.id] = {
          first_name: member.plus_one?.first_name || '',
          last_name: member.plus_one?.last_name || ''
        };
        initPlusOneFoodChoices[member.id] = member.plus_one?.food_choice || '';
        initPlusOneRestrictions[member.id] = member.plus_one?.food_restrictions || '';
        initPlusOneRehearsal[member.id] = member.plus_one?.rehearsal_res ? (member.plus_one.rehearsal_res ? 'Accept' : 'Decline') : '';
        initPlusOneRehearsalDinner[member.id] = member.plus_one?.rehearsal_dinner_res ? (member.plus_one.rehearsal_dinner_res ? 'Accept' : 'Decline') : '';
      }
    });

    setGroupMembers(members);
    setAttendance(initAttendance);
    setPlusOneAttendance(initPlusOneAttendance);
    setPlusOneNames(initPlusOneNames);
    setFoodChoices(initFoodChoices);
    setRestrictions(initRestrictions);
    setPlusOneFoodChoices(initPlusOneFoodChoices);
    setPlusOneRestrictions(initPlusOneRestrictions);
    setRehearsalAttendance(initRehearsalAttendance);
    setRehearsalDinnerAttendance(initRehearsalDinnerAttendance);
    setPlusOneRehearsal(initPlusOneRehearsal);
    setPlusOneRehearsalDinner(initPlusOneRehearsalDinner);
    setQuestionsVisible(true);
  };

  // Handlers
  const handleAttendance = (id, status) => {
    setAttendance(prev => ({ ...prev, [id]: status }));
    if (status === 'Decline') {
      setRehearsalAttendance(prev => ({ ...prev, [id]: 'Decline' }));
      setRehearsalDinnerAttendance(prev => ({ ...prev, [id]: 'Decline' }));
      setFoodChoices(prev => ({ ...prev, [id]: '' }));
      setRestrictions(prev => ({ ...prev, [id]: '' }));
      setPlusOneAttendance(prev => ({ ...prev, [id]: 'Decline' }));
      setPlusOneNames(prev => ({ ...prev, [id]: { first_name: '', last_name: '' } }));
      setPlusOneFoodChoices(prev => ({ ...prev, [id]: '' }));
      setPlusOneRestrictions(prev => ({ ...prev, [id]: '' }));
      setPlusOneRehearsal(prev => ({ ...prev, [id]: 'Decline' }));
      setPlusOneRehearsalDinner(prev => ({ ...prev, [id]: 'Decline' }));
    }
  };

  const handleFoodChoice = (id, choice) => setFoodChoices(prev => ({ ...prev, [id]: choice }));
  const handleRestrictionsChange = (id, value) => setRestrictions(prev => ({ ...prev, [id]: value }));
  const handlePlusOneAttendance = (id, status) => {
    setPlusOneAttendance(prev => ({ ...prev, [id]: status }));
    if (status === 'Decline') {
      setPlusOneNames(prev => ({ ...prev, [id]: { first_name: '', last_name: '' } }));
      setPlusOneFoodChoices(prev => ({ ...prev, [id]: '' }));
      setPlusOneRestrictions(prev => ({ ...prev, [id]: '' }));
      setPlusOneRehearsal(prev => ({ ...prev, [id]: 'Decline' }));
      setPlusOneRehearsalDinner(prev => ({ ...prev, [id]: 'Decline' }));
    }
  };

  const handlePlusOneNameChange = (id, field, value) =>
    setPlusOneNames(prev => ({ ...prev, [id]: { ...prev[id], [field]: value } }));

  const handlePlusOneFoodChoice = (id, choice) =>
    setPlusOneFoodChoices(prev => ({ ...prev, [id]: choice }));

  const handlePlusOneRestrictionsChange = (id, value) =>
    setPlusOneRestrictions(prev => ({ ...prev, [id]: value }));

  const handleRehearsalAttendance = (id, status) =>
    setRehearsalAttendance(prev => ({ ...prev, [id]: status }));

  const handleRehearsalDinnerAttendance = (id, status) =>
    setRehearsalDinnerAttendance(prev => ({ ...prev, [id]: status }));

  const handlePlusOneRehearsal = (id, status) =>
    setPlusOneRehearsal(prev => ({ ...prev, [id]: status }));

  const handlePlusOneRehearsalDinner = (id, status) =>
    setPlusOneRehearsalDinner(prev => ({ ...prev, [id]: status }));

  // RSVP Submission
  const handleRSVPSubmit = (members = groupMembers) => {
  // Optimistic UI update
  setRsvpSubmitted(true);

  // Prepare all RSVP requests concurrently
  const requests = members.map(member => {
    const attendingMain = attendance[member.id] === 'Accept';

    const rsvpData = {
      first_name: member.first_name,
      last_name: member.last_name,
      attending: attendingMain ? true : (attendance[member.id] === 'Decline' ? false : null),
      food_choice: attendingMain ? (foodChoices[member.id] || '') : '',
      food_restrictions: attendingMain ? (restrictions[member.id] || '') : '',
      rehearsal_res: member.rehearsal && attendingMain ? (rehearsalAttendance[member.id] === 'Accept') : false,
      rehearsal_dinner_res: member.rehearsal && attendingMain ? (rehearsalDinnerAttendance[member.id] === 'Accept') : false,
    };

    if (member.plus_one_id) {
      const plusOneAttending = plusOneAttendance[member.id] === 'Accept' && attendingMain;

      rsvpData.plus_one = {
        first_name: plusOneNames[member.id]?.first_name || '',
        last_name: plusOneNames[member.id]?.last_name || '',
        attending: plusOneAttending ? true : (plusOneAttendance[member.id] === 'Decline' ? false : null),
        food_choice: plusOneAttending ? (plusOneFoodChoices[member.id] || '') : '',
        food_restrictions: plusOneAttending ? (plusOneRestrictions[member.id] || '') : '',
        rehearsal_res: member.rehearsal && plusOneAttending ? (plusOneRehearsal[member.id] === 'Accept') : false,
        rehearsal_dinner_res: member.rehearsal && plusOneAttending ? (plusOneRehearsalDinner[member.id] === 'Accept') : false,
      };
    }

    // Return promise without awaiting — all requests run in parallel
    return axios.post('https://ww-backend-1-production.up.railway.app/rsvp', rsvpData)
      .catch(err => console.error('RSVP failed for', member.first_name, err));
  });

  // Run all requests concurrently
  Promise.all(requests).then(() => console.log('All RSVPs submitted!'));
  };


  return (
    <div className="rsvp-container">
      <img src={headerImage} alt="RSVP Header" className="rsvp-header-image" />
      <form onSubmit={handleFormSubmit} className="search-form">
        <label>First Name:
          <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
        </label>
        <></>
        <label>Last Name:
          <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
        </label>
        <button type="submit" className="search-btn black-button">FIND YOUR INVITATION</button>
      </form>

      {searchResult && <p className="search-result">{searchResult}</p>}

      {questionsVisible && (
        <div className="rsvp-form">
          {groupMembers.map(member => (
            <div key={member.id} className="guest-rsvp-block">
              <h3>{member.first_name} {member.last_name}</h3>

              {/* Main Attendance */}
              <div className="attendance-buttons">
                <button type="button" className={`rsvp-btn ${attendance[member.id] === 'Accept' ? 'selected' : ''}`}
                  onClick={() => handleAttendance(member.id, 'Accept')}>Accept</button>
                <button type="button" className={`rsvp-btn ${attendance[member.id] === 'Decline' ? 'selected' : ''}`}
                  onClick={() => handleAttendance(member.id, 'Decline')}>Decline</button>
              </div>

              {attendance[member.id] === 'Accept' && (
                <>
                  <div className="food-choice-boxes">
                    {['Braised Short Ribs', 'Pan Seared Salmon', 'Vegetarian'].map(option => (
                      <div key={option}
                        className={`food-box ${foodChoices[member.id] === option ? 'selected' : ''}`}
                        onClick={() => handleFoodChoice(member.id, option)}>
                        {option}
                      </div>
                    ))}
                  </div>

                  <label>
                    Dietary Restrictions or Allergies:
                    <input type="text" value={restrictions[member.id] || ''}
                      onChange={(e) => handleRestrictionsChange(member.id, e.target.value)} />
                  </label>

                  {member.rehearsal && (
                    <>
                      <p>Will you attend the rehearsal?</p>
                      <div className="attendance-buttons">
                        <button type="button"
                          className={`rsvp-btn ${rehearsalAttendance[member.id] === 'Accept' ? 'selected' : ''}`}
                          onClick={() => handleRehearsalAttendance(member.id, 'Accept')}>Accept</button>
                        <button type="button"
                          className={`rsvp-btn ${rehearsalAttendance[member.id] === 'Decline' ? 'selected' : ''}`}
                          onClick={() => handleRehearsalAttendance(member.id, 'Decline')}>Decline</button>
                      </div>

                      <p>Will you attend the rehearsal dinner?</p>
                      <div className="attendance-buttons">
                        <button type="button"
                          className={`rsvp-btn ${rehearsalDinnerAttendance[member.id] === 'Accept' ? 'selected' : ''}`}
                          onClick={() => handleRehearsalDinnerAttendance(member.id, 'Accept')}>Accept</button>
                        <button type="button"
                          className={`rsvp-btn ${rehearsalDinnerAttendance[member.id] === 'Decline' ? 'selected' : ''}`}
                          onClick={() => handleRehearsalDinnerAttendance(member.id, 'Decline')}>Decline</button>
                      </div>
                    </>
                  )}
                </>
              )}

              {/* Plus One */}
              {member.plus_one_id && attendance[member.id] === 'Accept' &&  (
                <>
                  <p>Will you be bringing a plus one?</p>
                  <div className="attendance-buttons">
                    <button type="button"
                      className={`rsvp-btn ${plusOneAttendance[member.id] === 'Accept' ? 'selected' : ''}`}
                      onClick={() => handlePlusOneAttendance(member.id, 'Accept')}>Yes</button>
                    <button type="button"
                      className={`rsvp-btn ${plusOneAttendance[member.id] === 'Decline' ? 'selected' : ''}`}
                      onClick={() => handlePlusOneAttendance(member.id, 'Decline')}>No</button>
                  </div>

                  {plusOneAttendance[member.id] === 'Accept' && attendance[member.id] === 'Accept' && (
                    <>
                      <label style={{ display: 'block' }}>
                        First Name: 
                        <input
                          type="text"
                          value={plusOneNames[member.id]?.first_name || ''}
                          onChange={(e) => handlePlusOneNameChange(member.id, 'first_name', e.target.value)}
                          required
                        />
                      </label>

                      <label style={{ display: 'block' }}>
                        Last Name: 
                        <input
                          type="text"
                          value={plusOneNames[member.id]?.last_name || ''}
                          onChange={(e) => handlePlusOneNameChange(member.id, 'last_name', e.target.value)}
                          required
                        />
                      </label>

                      <div className="food-choice-boxes">
                        {['Braised Short Ribs', 'Pan Seared Salmon', 'Vegetarian'].map(option => (
                          <div key={option}
                            className={`food-box ${plusOneFoodChoices[member.id] === option ? 'selected' : ''}`}
                            onClick={() => handlePlusOneFoodChoice(member.id, option)}>
                            {option}
                          </div>
                        ))}
                      </div>

                      <label>
                        Dietary Restrictions or Allergies:
                        <input type="text" value={plusOneRestrictions[member.id] || ''}
                          onChange={(e) => handlePlusOneRestrictionsChange(member.id, e.target.value)} />
                      </label>

                      {member.rehearsal && (
                        <>
                          <p>Will your plus one attend the rehearsal?</p>
                          <div className="attendance-buttons">
                            <button type="button"
                              className={`rsvp-btn ${plusOneRehearsal[member.id] === 'Accept' ? 'selected' : ''}`}
                              onClick={() => handlePlusOneRehearsal(member.id, 'Accept')}>Accept</button>
                            <button type="button"
                              className={`rsvp-btn ${plusOneRehearsal[member.id] === 'Decline' ? 'selected' : ''}`}
                              onClick={() => handlePlusOneRehearsal(member.id, 'Decline')}>Decline</button>
                          </div>

                          <p>Will your plus one attend the rehearsal dinner?</p>
                          <div className="attendance-buttons">
                            <button type="button"
                              className={`rsvp-btn ${plusOneRehearsalDinner[member.id] === 'Accept' ? 'selected' : ''}`}
                              onClick={() => handlePlusOneRehearsalDinner(member.id, 'Accept')}>Accept</button>
                            <button type="button"
                              className={`rsvp-btn ${plusOneRehearsalDinner[member.id] === 'Decline' ? 'selected' : ''}`}
                              onClick={() => handlePlusOneRehearsalDinner(member.id, 'Decline')}>Decline</button>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          ))}

          {!rsvpSubmitted && (
            <button className="submit-btn black-button" onClick={() => handleRSVPSubmit()}>
              Submit RSVP
            </button>
          )}

          {rsvpSubmitted && <p className="confirmation-message">We got your response, thanks!</p>}
        </div>
      )}
    </div>
  );
}

export default Rsvp;
